import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {PedidosService} from "../../services/pedidos.service";
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {NgForm} from "@angular/forms";
import {DialogService} from "@progress/kendo-angular-dialog";
import {ImageIfoodComponent} from "./imagem-ifood";

@Component({
  selector: 'app-acao-pedido-disputa',
  templateUrl: './acao-pedido-disputa.component.html',
  styleUrls: ['./acao-pedido-disputa.component.scss']
})
export class AcaoPedidoDisputaComponent implements OnInit {
  @Input() pedido: any = {};
  @Input() modoGrupoLojas = false;
  @ViewChild('frm', {}) frm: NgForm;
  public _submitted = false;
  erroDisputa: string
  processando: boolean;
  tempoRestante: any;
  minutosRestantes: number;
  documentosChargeback: Array<any> = [];
  motivoDesistenciaChargeback: string;
  sincronizandoChargeback = false;
  mensagemSincronizacaoChargeback: string;
  constructor( protected pedidosService: PedidosService, private grupolojasService: GrupolojasService,
               private dialogService: DialogService) { }

  ngOnInit(): void {
    this.setTempoResposta();
  }

  aceitarCancelarPedidoDaDisputa(){
    if( this.processando ) return;

    delete this.erroDisputa;
    this.processando = true;

    this.getService().finalizeDisputaComAceitar(this.pedido).then( (resp) => {
      this.processando = false;
      this.pedido.disputa.finalizada = true;
    }).catch( erro => {
      this.processando = false;
      this.erroDisputa = erro;
    })
  }

  naoAceitarCancelarPedidoDaDisputa(){
    if( this.processando ) return;

    delete this.erroDisputa;
    this.processando = true;

    this.getService().finalizeDisputaComRejeitar(this.pedido, this.pedido.motivoRejeitarDisputa,
      this.pedido.razaoRejeitar).then( (resp) => {
      this.processando = false;
      this.pedido.disputa.finalizada = true;
    }).catch( erro => {
      this.processando = false;
      this.erroDisputa = erro;
    })
  }


  enviePropostaDisputa(){
    this._submitted = true;

    if(this.frm.valid){
      if( this.processando ) return;

      delete this.erroDisputa;
      this.processando = true;

      this.getService().enviePropostaDisputa(this.pedido, this.pedido.proposta.acao, this.pedido.proposta.valor).then( (resp) => {
        this.processando = false;
        this.pedido.disputa.aguardandoProposta = true;
      }).catch( erro => {
        this.processando = false;
        this.erroDisputa = erro;
      })
    }
  }

  confirmeNaoAceitarCancelarPedidoDaDisputa(){
    this.pedido.confirmarRejeitarDisputa = true;
  }

  volteAceitarCancelarPedidoDisputa(){
    this.pedido.confirmarRejeitarDisputa = false;
  }


  setTempoResposta(){
    if(!this.pedido.disputa || this.pedido.disputa.finalizada) return;

    if(this.pedido.disputa.dataExpiracao){
      this.pedido.disputa.dataExpiracao = new Date(this.pedido.disputa.dataExpiracao)
      this.updateCountdown();


      setInterval(() => this.updateCountdown(), 1000);
    }
  }

  updateCountdown() {

    const now = new Date();

    const remainingTime = Math.max(0, this.pedido.disputa.dataExpiracao.getTime() - now.getTime());
    const minutes = Math.floor(remainingTime / 60000);
    const seconds = Math.floor((remainingTime % 60000) / 1000);
    this.tempoRestante = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    this.minutosRestantes = minutes;

  }

  getService(): any {
    return this.modoGrupoLojas ? this.grupolojasService : this.pedidosService;
  }

  verImagem(url: string){
    let altura = window.innerHeight - 100;
    const dialogRef = this.dialogService.open({
      title: 'Foto enviada pelo cliente',
      content: ImageIfoodComponent,
      minWidth: 600,
      width: window.innerWidth > 800 ? 800 : window.innerWidth,
      maxHeight: altura
    });

    let instence: any = dialogRef.content.instance;

    instence.imagemURL = url;
  }

  async selecioneDocumentosChargeback(evento: any){
    delete this.erroDisputa;
    const arquivos = Array.from(evento?.target?.files || []) as Array<File>;

    if(!arquivos.length) return;

    if(this.documentosChargeback.length + arquivos.length > 10){
      this.erroDisputa = 'Você pode enviar no máximo 10 documentos.';
      return;
    }

    try {
      for(const arquivo of arquivos){
        this.valideArquivoChargeback(arquivo);
        this.documentosChargeback.push(await this.leiaArquivoChargeback(arquivo));
      }
    } catch (erro) {
      this.erroDisputa = erro && erro.message ? erro.message : erro;
    } finally {
      if(evento?.target)
        evento.target.value = '';
    }
  }

  removaDocumentoChargeback(indice: number){
    this.documentosChargeback.splice(indice, 1);
  }

  envieDocumentacaoChargeback(){
    if(this.processando) return;

    delete this.erroDisputa;

    if(!this.documentosChargeback.length){
      this.erroDisputa = 'Adicione pelo menos um PDF ou JPG para defender a disputa.';
      return;
    }

    this.processando = true;
    this.pedidosService.envieDocumentacaoChargebackCellcoin(this.pedido, this.documentosChargeback, null)
      .then((resp: any) => {
        this.processando = false;
        if(resp?.disputa)
          this.pedido.disputa = resp.disputa;
        this.documentosChargeback = [];
      }).catch(erro => {
        this.processando = false;
        this.erroDisputa = erro;
      });
  }

  confirmeDesistirChargeback(){
    this.pedido.confirmarDesistirChargeback = true;
  }

  volteDesistirChargeback(){
    this.pedido.confirmarDesistirChargeback = false;
  }

  desistaChargeback(){
    if(this.processando) return;

    delete this.erroDisputa;
    this.processando = true;
    this.pedidosService.desistaDisputaChargebackCellcoin(this.pedido, this.motivoDesistenciaChargeback)
      .then((resp: any) => {
        this.processando = false;
        if(resp?.disputa)
          this.pedido.disputa = resp.disputa;
        this.pedido.confirmarDesistirChargeback = false;
      }).catch(erro => {
        this.processando = false;
        this.erroDisputa = erro;
      });
  }

  sincronizeChargeback(){
    if(this.sincronizandoChargeback) return;

    delete this.erroDisputa;
    delete this.mensagemSincronizacaoChargeback;
    this.sincronizandoChargeback = true;

    this.pedidosService.sincronizeDisputaChargebackCellcoin(this.pedido)
      .then((resp: any) => {
        this.sincronizandoChargeback = false;
        if(resp?.disputa)
          this.pedido.disputa = resp.disputa;
        this.mensagemSincronizacaoChargeback = resp?.alterado ?
          `Status atualizado para ${this.rotuloStatusChargebackCellcoin(resp.status)}.` : 'O status já está atualizado.';
      }).catch(erro => {
        this.sincronizandoChargeback = false;
        this.erroDisputa = erro;
      });
  }

  formateTamanhoDocumento(tamanho: number){
    if(!tamanho) return '';

    if(tamanho >= 1024 * 1024)
      return `${(tamanho / 1024 / 1024).toFixed(1)} MB`;

    return `${Math.ceil(tamanho / 1024)} KB`;
  }

  rotuloStatusChargebackCellcoin(status: string): string {
    if(!status) return '';

    const statusNormalizado = String(status).replace(/[^a-zA-Z]/g, '').toUpperCase();
    const descricoes: any = {
      AWAITINGDOCUMENTATION: 'Aguardando documentação',
      INANALYSIS: 'Em análise',
      WINDISPUTE: 'Disputa ganha',
      WINSDISPUTE: 'Disputa ganha',
      WON: 'Disputa ganha',
      LOSTDISPUTE: 'Disputa perdida',
      LOST: 'Disputa perdida',
      CHARGEBACK: 'Disputa perdida',
      CHARGEDBACK: 'Disputa perdida',
      REFUNDED: 'Disputa perdida e valor devolvido',
      REVERSED: 'Disputa perdida e valor revertido',
      DEBITED: 'Disputa perdida e valor debitado',
      CANCELEDDISPUTE: 'Disputa cancelada',
      CANCELED: 'Disputa cancelada',
      CANCELLED: 'Disputa cancelada',
      CLOSEDWITHOUTDEBIT: 'Encerrada sem débito'
    };
    const descricao = descricoes[statusNormalizado] || 'Status informado pela Cellcoin';

    return `${descricao} (${status})`;
  }

  private valideArquivoChargeback(arquivo: File){
    const tipo = String(arquivo.type || '').toLowerCase();
    const nome = String(arquivo.name || '').toLowerCase();
    const ehPdf = tipo === 'application/pdf' || nome.endsWith('.pdf');
    const ehJpg = tipo === 'image/jpeg' || tipo === 'image/jpg' || nome.endsWith('.jpg') || nome.endsWith('.jpeg');

    if(!ehPdf && !ehJpg)
      throw Error(`Arquivo ${arquivo.name} inválido. Envie apenas PDF ou JPG.`);

    if(ehPdf && arquivo.size > 2 * 1024 * 1024)
      throw Error(`Arquivo ${arquivo.name} excede o limite de 2MB para PDF.`);

    if(ehJpg && arquivo.size > 5 * 1024 * 1024)
      throw Error(`Arquivo ${arquivo.name} excede o limite de 5MB para JPG.`);
  }

  private leiaArquivoChargeback(arquivo: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const dataUrl = String(reader.result || '');
        resolve({
          nome: arquivo.name,
          contentType: arquivo.type || (arquivo.name.toLowerCase().endsWith('.pdf') ? 'application/pdf' : 'image/jpeg'),
          tamanho: arquivo.size,
          base64: dataUrl.indexOf(',') >= 0 ? dataUrl.split(',').pop() : dataUrl
        });
      };
      reader.onerror = () => reject('Falha ao ler arquivo ' + arquivo.name);
      reader.readAsDataURL(arquivo);
    });
  }

}
